import { defineComponent } from 'vue'
import TranslationsMixin from '@/util/TranslationsMixin'
import { UserBaseInfoData } from '@/Domain/User/Types/types'


export default defineComponent({
  mixins: [TranslationsMixin],
  data () {
    return {}
  },
  computed: {},
  methods: {
    getTranslatedTaxonomyName (taxonomy) {
      if (!taxonomy) return ''

      const currentLocale = this.locale

      // Check if translations exist for current locale
      if (taxonomy.translations && taxonomy.translations[currentLocale] && taxonomy.translations[currentLocale].name) {
        return taxonomy.translations[currentLocale].name
      }

      // Fallback to default name
      return taxonomy.name
    },
    getDepartmentName (user: UserBaseInfoData) {
      if (!user.department) return ''

      const department = this.$store.state.taxonomies.departments.find(d => d.id === Number(user.department))
      if (!department) return user.department

      return this.getTranslatedTaxonomyName(department)
    },
    // Get translated experience level name based on function ID
    getExperienceLevelName (user: UserBaseInfoData) {
      if (!user.function) return ''
      const experienceLevel = this.$store.state.taxonomies.experienceLevels.find(e => e.id === Number(user.function))
      if (!experienceLevel) return user.function

      return this.getTranslatedTaxonomyName(experienceLevel)
    },
  },
})
